module.exports = __webpack_public_path__ + "img/5.36201f81.svg";